// extracted by mini-css-extract-plugin
export var dividerLine = "_94-3";
export var itemImage = "_94-9";
export var lightDivider = "_94-4";
export var modalContent = "_94-5";
export var modalContentCompact = "_94-6";
export var productCard = "_94-a";
export var productImage = "_94-b";
export var productImageCompact = "_94-7";
export var productImagePlaceholder = "_94-c";
export var productImagePlaceholderCompact = "_94-8";
export var progressBarBackground = "_94-1";
export var progressBarContainer = "_94-0";
export var progressBarFill = "_94-2";